// extracted by mini-css-extract-plugin
export var collapsedSummary = "_rr-0";